"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RaindropsProgram = exports.NamespaceIndex = exports.NamespaceGatekeeper = exports.Namespace = exports.convertTokenType = exports.TokenType = exports.FilterNamespaces = exports.FilterType = exports.Filter = exports.ArtifactFilter = exports.convertPermissiveness = exports.Permissiveness = exports.PermissivenessSettings = void 0;
const anchor_1 = require("@project-serum/anchor");
const pids = __importStar(require("../constants/programIds"));
class PermissivenessSettings {
}
exports.PermissivenessSettings = PermissivenessSettings;
var Permissiveness;
(function (Permissiveness) {
    Permissiveness["All"] = "ALL";
    Permissiveness["Whitelist"] = "WHITELIST";
    Permissiveness["Blacklist"] = "BLACKLIST";
    Permissiveness["Namespace"] = "NAMESPACE";
})(Permissiveness = exports.Permissiveness || (exports.Permissiveness = {}));
// conver enum to an anchor compatible type
function convertPermissiveness(p) {
    switch (p) {
        case Permissiveness.All:
            return { all: {} };
        case Permissiveness.Whitelist:
            return { whitelist: {} };
        case Permissiveness.Blacklist:
            return { blacklist: {} };
        case Permissiveness.Namespace:
            return { namespace: {} };
        default:
            throw new Error("Invalid Permissiveness");
    }
}
exports.convertPermissiveness = convertPermissiveness;
class ArtifactFilter {
}
exports.ArtifactFilter = ArtifactFilter;
class Filter {
    constructor(filterType, filterData) {
        const filterNs = filterData;
        const filterKeys = filterData;
        switch (filterType) {
            case FilterType.FilterNamespaces:
                this.filter = { namespace: { namespaces: filterNs.namespaces } };
                break;
            case FilterType.FilterKey:
                this.filter = {
                    key: {
                        key: filterKeys.key,
                        mint: filterKeys.mint,
                        metadata: filterKeys.metadata,
                        edition: filterKeys.edition,
                    },
                };
                break;
        }
    }
}
exports.Filter = Filter;
var FilterType;
(function (FilterType) {
    FilterType["FilterNamespaces"] = "NAMESPACES";
    FilterType["FilterCategories"] = "CATEGORIES";
    FilterType["FilterKey"] = "KEY";
})(FilterType = exports.FilterType || (exports.FilterType = {}));
class FilterNamespaces {
    constructor(namespaces) {
        this.namespaces = namespaces;
    }
}
exports.FilterNamespaces = FilterNamespaces;
var TokenType;
(function (TokenType) {
    TokenType["Player"] = "PLAYER";
    TokenType["Item"] = "ITEM";
    TokenType["Mission"] = "MISSION";
    TokenType["Namespace"] = "NAMESPACE";
})(TokenType = exports.TokenType || (exports.TokenType = {}));
// conver enum to an anchor compatible type
function convertTokenType(tokenType) {
    switch (tokenType) {
        case TokenType.Item:
            return { item: {} };
        case TokenType.Mission:
            return { mission: {} };
        case TokenType.Namespace:
            return { namespace: {} };
        case TokenType.Player:
            return { player: {} };
        default:
            throw new Error("Invalid TokenType");
    }
}
exports.convertTokenType = convertTokenType;
class Namespace {
    constructor(key, data) {
        this.key = key;
        this.namespaces = data.namespaces;
        this.mint = data.mint;
        this.metadata = data.metadata;
        this.masterEdition = data.masterEdition;
        this.uuid = data.uuid;
        this.prettyName = data.prettyName;
        this.artifactsAdded = data.artifactsAdded.toNumber();
        this.maxPages = data.maxPages.toNumber();
        this.fullPages = data.fullPages;
        this.artifactsCached = data.artifactsCached.toNumber();
        this.permissivenessSettings = data.permissivenessSettings;
        this.bump = data.bump;
        this.whitelistedStakingMints = data.whitelistedStakingMints;
        this.gatekeeper = data.gatekeeper;
        this.paymentAmount = data.paymentAmount
            ? data.paymentAmount.toNumber()
            : null;
        this.paymentMint = data.paymentMint;
        this.paymentVault = data.paymentVault;
    }
    print(log) {
        var _a, _b;
        log.info("Namespace:", this.key.toBase58());
        log.info(`Namespaces: ${this.namespaces ? "[" : "[]"}`);
        if (this.namespaces) {
            this.namespaces.map((n) => {
                log.info(`{`);
                log.info(`\tnamespace: ${n.namespace.toBase58()}`);
                log.info(`\tindex: ${n.index}`);
                log.info(`\tinherited: ${Object.keys(n.inherited).join(", ")}`);
                log.info(`}`);
            });
            log.info("]");
        }
        log.info("Mint:", this.mint ? this.mint.toBase58() : "Not cached on object");
        log.info("Metadata:", this.metadata ? this.metadata.toBase58() : "Not cached on object");
        log.info("Master Edition:", this.masterEdition
            ? this.masterEdition.toBase58()
            : "Not cached on object");
        log.info("UUID:", this.uuid ? this.uuid : "Not cached on object");
        log.info("Pretty Name:", this.prettyName ? this.prettyName : "Not cached on object");
        log.info("Artifacts Added:", this.artifactsAdded ? this.artifactsAdded : "Not cached on object");
        log.info("Max Pages:", this.maxPages ? this.maxPages : "Not cached on object");
        log.info("Aritfacts Cached:", this.artifactsCached ? this.artifactsCached : "Not cached on object");
        log.info("Permissiveness Settings: {");
        log.info(`\tNamespace Permissiveness: ${Object.keys(this.permissivenessSettings.namespacePermissiveness).join(", ")}`);
        log.info(`\tItem Permissiveness: ${Object.keys(this.permissivenessSettings.itemPermissiveness).join(", ")}`);
        log.info(`\tPlayer Permissiveness: ${Object.keys(this.permissivenessSettings.playerPermissiveness).join(", ")}`);
        log.info(`\tMatch Permissiveness: ${Object.keys(this.permissivenessSettings.matchPermissiveness).join(", ")}`);
        log.info(`\tMission Permissiveness: ${Object.keys(this.permissivenessSettings.missionPermissiveness).join(", ")}`);
        log.info(`\tCache Permissiveness: ${Object.keys(this.permissivenessSettings.cachePermissiveness).join(", ")}`);
        log.info("}");
        log.info("Bump:", this.bump ? this.bump : "Not cached on object");
        log.info(`Whitelist Staking Mints: [${((_a = this.whitelistedStakingMints) === null || _a === void 0 ? void 0 : _a.length) > 0 ? "" : "]"}`);
        if (((_b = this.whitelistedStakingMints) === null || _b === void 0 ? void 0 : _b.length) > 0) {
            this.whitelistedStakingMints.map((wlStakingMint) => {
                log.info(`\t${wlStakingMint.toBase58()}`);
            });
            log.info("]");
        }
        if (this.paymentAmount) {
            log.info(`Payment Amount: ${this.paymentAmount}`);
        }
        if (this.paymentMint) {
            log.info(`Payment Mint: ${this.paymentMint.toString()}`);
        }
        if (this.paymentVault) {
            log.info(`Payment Vault: ${this.paymentVault.toString()}`);
        }
    }
}
exports.Namespace = Namespace;
class NamespaceGatekeeper {
    constructor(address, data) {
        this.address = address;
        this.artifactFilters = data.artifactFilters;
        this.namespace = data.namespace;
        this.bump = data.bump;
    }
}
exports.NamespaceGatekeeper = NamespaceGatekeeper;
class NamespaceIndex {
    constructor(address, data) {
        this.address = address;
        this.namespace = data.namespace;
        this.bump = data.bump;
        this.page = data.page;
        this.caches = data.caches;
    }
}
exports.NamespaceIndex = NamespaceIndex;
var RaindropsProgram;
(function (RaindropsProgram) {
    RaindropsProgram[RaindropsProgram["Item"] = 0] = "Item";
    RaindropsProgram[RaindropsProgram["Namespace"] = 1] = "Namespace";
    RaindropsProgram[RaindropsProgram["Matches"] = 2] = "Matches";
    RaindropsProgram[RaindropsProgram["Staking"] = 3] = "Staking";
    RaindropsProgram[RaindropsProgram["Player"] = 4] = "Player";
})(RaindropsProgram = exports.RaindropsProgram || (exports.RaindropsProgram = {}));
(function (RaindropsProgram) {
    function getRaindropsProgram(program) {
        switch (program) {
            case RaindropsProgram.Item:
                return pids.ITEM_ID;
            case RaindropsProgram.Namespace:
                return pids.NAMESPACE_ID;
            case RaindropsProgram.Matches:
                return pids.MATCHES_ID;
            case RaindropsProgram.Player:
                return pids.PLAYER_ID;
            case RaindropsProgram.Staking:
                return pids.STAKING_ID;
            default:
                throw new Error(`Unknown RaindropsProgram: ${program}`);
        }
    }
    RaindropsProgram.getRaindropsProgram = getRaindropsProgram;
    function getRaindropsProgramFromAddress(addressStr) {
        const address = new anchor_1.web3.PublicKey(addressStr);
        if (address.equals(pids.ITEM_ID)) {
            return RaindropsProgram.Item;
        }
        else if (address.equals(pids.NAMESPACE_ID)) {
            return RaindropsProgram.Namespace;
        }
        else if (address.equals(pids.MATCHES_ID)) {
            return RaindropsProgram.Matches;
        }
        else if (address.equals(pids.PLAYER_ID)) {
            return RaindropsProgram.Player;
        }
        else if (address.equals(pids.STAKING_ID)) {
            return RaindropsProgram.Staking;
        }
        throw new Error(`Unknown RaindropsProgram: ${address}`);
    }
    RaindropsProgram.getRaindropsProgramFromAddress = getRaindropsProgramFromAddress;
})(RaindropsProgram = exports.RaindropsProgram || (exports.RaindropsProgram = {}));
